<template>
	<div class="business-article">
		<div class="column">
			<div class="content">
				<div class="content-inner u-pt4em-pc">
					<p class="content-catch u-wsn-pc u-LS10-pc u-MT2em-sp">
						技術難易度の高いソフトウェア開発支援だけではなく、<br />ソフトウェア開発に携わる技術者の育成・スキルアップも手掛ける。
					</p>
					<div class="content-text">
						<p>
							エンベデッド領域では、自動運転の進化やロボットの高機能化に見られるように、ソフトウェアによって多くの機能が実現されているだけでなく、安全やセキュリティの実現にもソフトウェアが深く関わるようになってきています。そうした状況に加え、電子マネーのシステムとクレジットカードのシステムを組み合わせてオートチャージ可能な電子マネーを作ったように、システムを組み合わせて新たな価値を生み出していく“システムオブシステムズ”の考え方が主流になってきました。また、AI、クラウドといった、新たな技術の取り込みも進んでおり、「ソフトウェアファースト」という言葉に代表されるように、ソフトウェアの重要性が年々高まっています。
						</p>
						<p>
							そうしたソフトウェアの実現には大規模化、複雑化、高信頼化に伴う問題の解決が不可欠ですが、それには高い技術力を必要とします。豆蔵は強みであるオブジェクト指向やモデルベースによる抽象化技術を含めたシステムズエンジニアリングやソフトウェアエンジニアリングを活用し、開発、コンサルティング、技術者教育の3種類の支援を行うことで独自のポジションを築いています。
						</p>
						<p>
							開発では、先進技術に強いという特徴を活かし、企業の研究開発部門でのR&Dの支援や、技術検証のためのPoC(Proof of
							Concept)開発の支援を数多く行っています。そして、コンサルティングでは、システムズエンジニアリング、ソフトウェアエンジニアリング、モデリングの知見を活かして、安全規格やセキュリティ規格対応、プロセス構築・プロセス改善、エンジニアリング改善を行っている企業を支援しています。また、様々なものがソフトウェアによって実現される現在、企業競争力の源泉となるソフトウェア開発力を外部に頼らず自身で持つ「内製化」が重要なテーマになっています。そのため自社のソフトウエア技術者の育成・スキルアップが急務となっている企業が数多く存在しています。そうした企業に対し、豆蔵は技術者教育として、自社開発の教育コンテンツを利用したトレーニングを提供することで内製化の促進という面でも実績を残しています。
						</p>
					</div>
				</div>
			</div>
		</div>
		<!-- ビジネスプラットフォーム領域の強み -->
		<article class="column">
			<div class="title-wrap">
				<h3 class="title-wrap-inner">
					エンベデッド領域の強み
				</h3>
			</div>
			<div class="content">
				<div class="content-inner u-pt6em-pc">
					<div class="content-lead">
						<div class="content-num content-num--1">
							<img src="../../assets/common/num01.svg" alt="1" width="51" height="52" />
						</div>
						<p class="content-catch">エンジニアリングに基づく支援</p>
					</div>
					<div class="content-text u-mt2em-pc">
						<p>
							ソフトウェア開発の支援は経験に基づくものも重要ですが、経験に基づくだけでは網羅的な支援はできず、自身が経験したもの以上に良い方法が存在することにも気づけません。豆蔵はシステムズエンジニアリング、ソフトウェアエンジニアリングといったものづくりにおける原理原則を踏まえることで、それらの問題を解決しつつ、そこに経験を乗せた形で支援を行っています。
						</p>
						<p>
							また、現在のソフトウェア開発において無視できないものとなっている安全規格やセキュリティ規格は、システムズエンジニアリングやソフトウェアエンジニアリングを理解していることが前提となっています。豆蔵はそうした規格の解釈についても、エンジニアリングの知見を活かすことで、規格が本当に求めていることは何かを理解した上で支援を行っています。
						</p>
					</div>
					<div class="content-lead">
						<div class="content-num">
							<img src="../../assets/common/num02.svg" alt="2" width="62" height="52" />
						</div>
						<p class="content-catch">すべての根底となるモデリング技術</p>
					</div>
					<div class="content-text u-mt2em-pc">
						<p>
							豆蔵は1999年の創業以来、モデリング技術をエンジニアの基本スキルとして重要視しています。現在注目されているMBSE(Model-Based
							Systems Engineering)やMBD(Model-Based Development)、DDD(Domain Driven
							Design)といった技術はすべてモデリングスキルが中核となっています。DXにおいても、そもそもの「業務の理解」のためには業務のモデル化が必須です。また、デザイン思考といったイノベーションの分野でもモデリングは見える化のための必須技術となっています。豆蔵はこうしたモデリングについて長年の経験を重ねており、様々なノウハウを持っています。
						</p>
					</div>
					<div class="content-lead">
						<div class="content-num">
							<img src="../../assets/common/num03.svg" alt="3" width="63" height="52" />
						</div>
						<p class="content-catch">
							人材育成支援
						</p>
					</div>
					<div class="content-text u-mt2em-pc">
						<p>
							豆蔵は製品開発支援やコンサルティングだけでなく、人材育成のためのトレーニングコンテンツを自社開発の形で持っていることも他社との大きな違いになっています。このトレーニングコンテンツは、ソフトウェア開発(要求～仕様～アーキテクチャ設計～設計～テスト)、プロジェクトマネジメント、品質技術(レビュー、静的解析)、システムズエンジニアリング、オブジェクト指向技術等、多くの技術領域に対応するものが用意されており、製品開発の現場で直面する大抵の問題に対応可能です。また、これらのトレーニングコンテンツの背景には豆蔵独自のエンジニアリング体系があり、それに基づいて各コンテンツが作られているため、コンテンツ同士で内容が矛盾したり、用語の意味が違ってしまうようなことがありません。
						</p>
						<p>
							このトレーニングコンテンツは、通常の開発支援の中で行われる現場でのOJTだけでなく、体系的な知識の獲得のためのトレーニングとしても提供できます。顧客のエンジニアのスキル状況や必要なエンジニア像に合わせたスキルアップカリキュラムを提供でき、顧客へのスムーズな技術移管や外部会社に依存しない開発体制の確立を支援することができるのです。これは現在のソフトウェア開発における大きな潮流である内製化の実現にも繋がります。
						</p>
					</div>
				</div>
			</div>
		</article>
		<!-- 代表的なプロジェクト事例 -->
		<article class="column">
			<div class="title-wrap">
				<h3 class="title-wrap-inner">
					代表的なプロジェクト事例
				</h3>
			</div>
			<div class="content">
				<div class="content-inner u-pb5em-pc">
					<div class="content-iconFlex">
						<div class="content-iconContainer">
							<div class="content-icon content-icon--1">
								<img src="../../assets/embedded/icon_car.svg" alt="" width="115" height="61" />
							</div>
							<p class="content-iconText">
								自動車関連
							</p>
						</div>
						<div class="content-text u-mt0-pc">
							<p class="content-textLead">
								大手メーカーのMaaS関連プロジェクトをリード
							</p>
							<p>
								豆蔵ではこれまで、大手自動車メーカーやサプライヤーに対して、様々なソリューションを提供しています。新規性の高い製品を実現するための支援としてパーソナルモビリティや次世代コクピット、モビリティサービスのためのプラットフォーム等の開発支援やPoCによる技術検証を行ったり、新しい製品開発プロセス立ち上げの支援としてMBSEプロセス、及び、MBDプロセスの構築(AutomotiveSPICE対応やISO26262対応を含む)やモデルの提供(SysML,
								UML,
								Simulink)、モデルベース開発のための環境整備(モデルチェックツール開発、ツールチェーン検討、トレーサビリティ実現方法の検討)といった支援を行っています。
							</p>
						</div>
					</div>
					<div class="content-iconFlex">
						<div class="content-iconContainer">
							<div class="content-icon content-icon--2">
								<img src="../../assets/embedded/icon_printer.svg" alt="" width="91" height="105" />
							</div>
							<p class="content-iconText">
								複写機メーカー
							</p>
						</div>
						<div class="content-text u-mt0-pc">
							<p class="content-textLead">プロダクトライン開発を支えるプラットフォームを開発</p>
							<p>
								某複写機メーカーで多種多様な製品が派生開発によって開発されている事業に対し、派生開発のベースとなる組込ソフトウェアの立ち上げを行いました。この開発では、「そもそも複写機は何をしなければならない機械なのか？」を徹底的に考え、モデル化することからプロジェクトをスタートしました。そして、多くの複写機の共通の土台となる普遍的なアーキテクチャの設計、フレームワーク化を行いました。また、そのソフトウェアを使った派生開発を実践していくためのプロダクトライン開発対応プロセスの定義、トレーニングやレビューによるお客様開発メンバーのモデリングスキル獲得支援、仕様書の書き方やコードレビュー等、様々な形で支援を行いました。このソフトウェアはその後多くのプロダクトで派生され続け、立ち上げから20年近くたった今でも進化を続けています。
							</p>
						</div>
					</div>
					<div class="content-iconFlex">
						<div class="content-iconContainer">
							<div class="content-icon content-icon--3">
								<img src="../../assets/embedded/icon_head.svg" alt="" width="98" height="117" />
							</div>
							<p class="content-iconText">
								人材育成
							</p>
						</div>
						<div class="content-text u-mt0-pc">
							<p class="content-textLead">
								大手製造業向け人材育成制度の導入
							</p>
							<p>
								大手製造業のクライアントに対して、ソフトウェア領域の人材育成制度を企画して導入しました。中長期での事業計画を見据えて、ソフトウェア人材に必要なスキルセットを定義。そのスキルを身につけてもらうために、入社以降の研修やキャリアパス、職級ごとの認定試験をパッケージ化して提供しました。数多くのトレーニングを手掛けてきた豆蔵のノウハウがベースになっています。
							</p>
						</div>
					</div>
				</div>
			</div>
		</article>
		<!-- エンベデッド領域の組織構成 -->
		<article class="column">
			<div class="title-wrap">
				<h3 class="title-wrap-inner">
					エンベデッド領域の組織構成
				</h3>
			</div>
			<div class="content">
				<div class="content-inner u-pt5em-pc u-pb55em-pc">
					<div class="content-text u-mt0-pc u-MT2em-sp">
						<p>
							エンベデッド領域の支援を行うチームには、エンジニアリング教育とモデリングを中核としたチームと、テスト・プロセス改善を中核としたチームの2つのチームがあります。それぞれのチームが得意とする領域はありつつも、プロジェクトの課題に合わせてチームの垣根なく連携しながら支援を行っています。
						</p>
						<p>
							また、支援内容についても、教育専任、開発専任のような形にはなっておらず、メンバーは開発、コンサルティング、技術者教育の3つの支援のいずれにも対応しています。こうすることで開発を中心としている人も教育支援の経験があるので、現場でOJTのトレーナとしての役割をこなすことができたり、講師を担当している人も現場でのコンサルティングの経験があるので、受講者の質問に現場の状況を踏まえた回答ができるようになっています。
							また、豆蔵の中心となる拠点は東京ですが、名古屋にも拠点があり、そこで活動しているチームもあります。名古屋のチームも東京のチームと同じように、開発、コンサルティング、技術者教育の支援をしており、東京のチームと連携しての支援も行っています。
						</p>
					</div>
				</div>
			</div>
		</article>
		<!-- 今後の展望 -->
		<article class="column">
			<div class="title-wrap">
				<h3 class="title-wrap-inner">
					今後の展望
				</h3>
			</div>
			<div class="image">
				<img src="../../assets/embedded/photo01.jpg" alt="" width="1840" height="600" />
			</div>
			<div class="content">
				<div class="content-inner underImage u-pb3em-pc">
					<p class="content-catch">
						これからの時代のソフトウェア開発にむけて
					</p>
					<div class="content-text u-mt2em-pc">
						<p>
							今後、ソフトウェアはますます社会活動や人の命や資産に大きく関わっていくことが容易に想像できますが、そうしたソフトウェアの実現にはエンジニアリングの実践が不可欠です。また、機械学習やクラウドの出現に見られるように日々、新しい技術も生み出されていきます。しかし、現在の日本のソフトウェア開発の現場を見ているとエンジニアリングの実践には遠く、新しい技術の習得にも手一杯となっている組織が数多くあります。また、そうした組織の中で疲弊してしまっているソフトウェア技術者も数多くいます。我々はエンジニアリングが実践できる組織・技術者を増やし、新しい技術の浸透を支援していくことで、そうした状況を改善し、新しいイノベーションを生み出すことに目を向けられるようにソフトウェア業界を変えていければと考えています。
						</p>
						<p>
							「一粒の知性がソフトウェアエンジニアリングを変える」は弊社設立時以来の理念ですが、今もこのビジョンは持ち続けており、我々(一粒の知性)が多くの企業のソフトウェアエンジニアリングを革新していくことで日本のソフトウェア開発を取り巻く状況を変えていければと考えています。
						</p>
					</div>
				</div>
			</div>
		</article>
		<!-- 求める人物像 -->
		<article class="column">
			<div class="title-wrap">
				<h3 class="title-wrap-inner">
					求める人物像
				</h3>
			</div>
			<div class="content">
				<div class="content-inner bgGray u-pt4em-pc">
					<p class="content-catch">
						新しい技術を習得していくのが好きで、<br class="over_display" />困難な技術課題を解決していくことにワクワクする人
					</p>
					<div class="content-text u-mt3em-pc">
						<p>
							新しい技術を習得していくのが好きで、困難な技術課題を解決していくことにワクワクするというマインドは豆蔵のエンジニアに共通している特徴です。また、常に新しい技術や話題を追いかけているだけでなく、得た知識やスキルを社内で共有し、社外にも発信しながら一緒に高めあっていきたいという気持ちがあるのも豆蔵のエンジニア特有の部分ではないかと思います。
						</p>
						<p>
							そして、そうしたエンジニアがいるからこそ、誰も見たことがないような新規性の高い開発や他社が手を挙げなかった高難度の開発といった、豆蔵らしい挑戦ができています。そうした環境に身を置き、成長していきたい、挑戦していきたいという方を求めています。
						</p>
					</div>
				</div>
			</div>
		</article>
		<!-- 活躍事例 -->
		<article class="column">
			<div class="title-wrap">
				<h3 class="title-wrap-inner u-ls10-pc">
					活躍事例
				</h3>
			</div>
			<div class="content">
				<div class="content-inner u-pt65em-pc">
					<div class="content-iconFlex --person">
						<div class="content-iconContainer --person">
							<div class="content-icon">
								<img src="../../assets/business_platform/icon_person.svg" alt="" width="113" height="120" />
							</div>
							<p class="content-iconText">
								Aさん
							</p>
						</div>
						<div class="content-text u-mt0-pc">
							<p class="u-mt0-pc">
								大手電機メーカー出身。ソフトウェアエンジニアリング、モデリングに関係した仕事をしたいと豆蔵に入社。以来、UMLやSysMLを活用しながら、モデルベースのプロセス定義と定着、アーキテクチャ改善といった案件を様々な業種で実践。書籍の執筆も経験し、対外的な発信も行っている。
							</p>
						</div>
					</div>
					<div class="content-iconFlex --person">
						<div class="content-iconContainer --person">
							<div class="content-icon">
								<img src="../../assets/business_platform/icon_person.svg" alt="" width="113" height="120" />
							</div>
							<p class="content-iconText">
								Bさん
							</p>
						</div>
						<div class="content-text u-mt0-pc">
							<p class="u-mt0-pc">
								大手複写機メーカーや車載部品メーカーでオブジェクト指向開発の導入やプロダクトライン開発の立上げを経験。管理職でなく再度技術者として現場で自身の知見を活かしたいと豆蔵へ入社。以来、医療機器開発といったこれまでとは異なる業界にも飛び込みながらコンサルタントとして活躍中。
							</p>
						</div>
					</div>
					<div class="content-iconFlex --person">
						<div class="content-iconContainer --person">
							<div class="content-icon">
								<img src="../../assets/business_platform/icon_person.svg" alt="" width="113" height="120" />
							</div>
							<p class="content-iconText">
								Cさん
							</p>
						</div>
						<div class="content-text u-mt0-pc">
							<p class="u-mt0-pc">
								長年、精密機器メーカーでの社内コンサルティングを経験。定年退職間際になってきたが、これからも技術を活かして現場でやっていきたいと考え、豆蔵へ入社。以来、これまでの知見を活かしながら、若手エンジニアと一緒にお客様のエンジニア育成改革を進めている。このまま65才を超えてもやっていきたいと考えている。
							</p>
						</div>
					</div>
				</div>
			</div>
		</article>
		<!-- キーマンインタビュー１ -->
		<article class="column keyman">
			<div class="keyman_flex">
				<h3 class="keyman_title">
					<span class="top"
						>キーマンインタビュー<img src="../../assets/common/num01_white.svg" alt="1" width="22" height="23"
					/></span>
					<span class="mid">一人ひとりのエンジニアの<br />成長が最重要</span>
					<span class="bottom">事業部長：Mitsuo</span>
				</h3>
				<div class="keyman_image">
					<img src="../../assets/embedded/photo02.jpg" alt="" width="1260" height="760" />
				</div>
			</div>
			<div class="content u-bg0-pc">
				<div class="content-inner underImage">
					<div class="content-text --interview u-mt0">
						<p class="u-mt0">
							前職では、複写機メーカーの情報子会社で複写機のソフトウェア開発にオブジェクト指向技術を使って実践。豆蔵の社員に声をかけられ2000年に豆蔵へ入社し、オブジェクト指向導入、プロセス改善などのコンサルティングを実施、その後、事業部長として組織のマネージメントを行っています。
						</p>
						<p>
							事業部として最も重視しているのは、一人ひとりのエンジニアの成長です。クライアントのエンジニアへの教育プログラムを提供する会社ですから、そのノウハウは自社のエンジニア教育にも活きています。また、プロジェクトを獲得する際には、アサインするエンジニアの技術志向や成長を見据えて提案を行います。営業とコンサルタントがタッグを組んで案件を獲得することで、クライアントとエンジニア間のギャップを最小限に抑えているのです。
						</p>
						<p>
							豆蔵は技術を売りにしている会社です。クライアントからお声掛けをいただく中で、新規開発のご相談が多くを占めています。この特徴に魅力を感じて、これまで既存製品の派生開発中心に行っていたメーカーのエンジニアがジョインしてくれることが多いです。既存製品の機能追加を行う開発ではなく、ゼロからクライアントと一緒になって発想し新しいモノづくり、新しい技術にチャレンジできる。そのような機会を求める方には、豆蔵のエンベデッド領域はこれ以上ない環境となるでしょう。
						</p>
					</div>
				</div>
			</div>
		</article>
		<!-- キーマンインタビュー２ -->
		<article class="column keyman">
			<div class="keyman_flex">
				<h3 class="keyman_title">
					<span class="top"
						>キーマンインタビュー<img src="../../assets/common/num02_white.svg" alt="1" width="28" height="23"
					/></span>
					<span class="mid">学ぶこと、<br />伝えることを大事に</span>
					<span class="bottom">CTO：Tatsuki</span>
				</h3>
				<div class="keyman_image">
					<img src="../../assets/embedded/photo03.jpg" alt="" width="1260" height="760" />
				</div>
			</div>
			<div class="content u-bg0-pc">
				<div class="content-inner underImage">
					<div class="content-text --interview u-mt0">
						<p class="u-mt0">
							97年に新卒としてオブジェクト指向のコンサルティングを行う会社に入社。その後、創業時の社長に声をかけられ2000年に二人目の社員として豆蔵に入社しました。以来、100社以上にオブジェクト指向、モデリング(UML/SysML等)、ソフトウェアエンジニアリング、システムズエンジニアリング等、様々な技術の導入コンサルティング、トレーニングを実施してきました。2020年よりCTOに就任しました。
						</p>
						<p>
							豆蔵のエンジニアは自律的に新しいことを学んでいく人が多いですが、ただ学ぶだけでなく、得たものを他の人に伝えることにも積極的な人が多いのが特徴です。社内で何か質問が出れば、それがどんなにニッチな技術であろうと答える人が出てきますし、豆蔵デベロッパーブログやWebメディアの記事、雑誌記事、書籍、学会発表、イベントでの登壇という形で自身の知見を外部に発信しているエンジニアもたくさんいます。
						</p>
						<p>
							そうした、社員の学ぶこと伝えることに関するモチベーションは豆蔵の競争力の源泉であり、それが豆蔵らしさを形作る重要な要素のひとつであると考えています。現在も、社内での勉強会や毎月の豆寄席(外部から人を招いてのオープンな勉強会)、eラーニング受講環境の整備、自社教育コンテンツの社内実施、資格獲得奨励制度等、様々な支援を実施しています。学びたい人・伝えたい人にとって魅力的な会社であるよう、これからも充実を進めていきたいです。
						</p>
					</div>
				</div>
			</div>
		</article>
	</div>
</template>

<script>
// @ is an alias to /src
// import News from '@/components/News.vue';
export default {
	name: 'embedded-article',
};
</script>

<style lang="scss" scoped>
// * {
// 	color: red !important;
// }
@keyframes gradientAnime {
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
}
.business-article {
	max-width: 920px;
	width: 100%;
	position: relative;
	margin: 0 auto;
	margin-bottom: 100px;
}
.column {
	position: relative;
	margin: 0 auto;
	margin-bottom: 140px;
	@media print, screen and (max-width: 1160px) {
		width: 90%;
		margin-bottom: 100px;
	}
	&:after {
		content: '';
		width: 150%;
		height: 300px;
		display: block;
		background: linear-gradient(to right, #ffcf82 0%, #543194 100%);
		background-size: 200% 200%;
		animation: gradientAnime 10s ease infinite;
		position: absolute;
		// top: 0;
		transform: skewY(-20deg);
		transform-origin: left top;
		z-index: -1;
	}
	&:before {
		content: '';
		width: 100%;
		height: 300px;
		display: block;
		background: linear-gradient(to right, #ffcf82 0%, #543194 100%);
		background-size: 200% 200%;
		animation: gradientAnime 10s ease infinite;
		position: absolute;
		// bottom: 0;
		transform: skewY(-20deg);
		transform-origin: left top;
		z-index: -1;
	}
	&:nth-child(1) {
		&:after {
			content: none;
			// width: 150%;
			// top: 0;/
			// transform-origin: left top;
		}
		&:before {
			content: none;
			// width: 100%;
			// bottom: 0;
			// transform-origin: left top;
			// left: -50%;
		}
	}
	// ビジネスプラットフォーム領域の強み
	&:nth-child(2) {
		&:after {
			width: 150%;
			// top: 30%;
			// transform-origin: left top;
			// width: 100vw;
			top: -10%;
			left: -10%;
			transform-origin: left top;
			@media print, screen and (min-width: 920px) {
				top: 5%;
				left: 0;
			}
		}
		&:before {
			// width: 100%;
			// bottom: -20%;
			// transform-origin: left top;
			// left: -50%;
			width: 150%;
			bottom: -5%;
			transform-origin: left top;
			left: -10%;
			@media print, screen and (min-width: 920px) {
				transform-origin: right top;
				left: auto;
				right: 1px;
				bottom: 15%;
				width: 100vw;
			}
		}
	}
	// 代表的なプロジェクト事例
	&:nth-child(3) {
		&:after {
			content: none;
		}
		&:before {
			content: none;
		}
	}
	// ビジネスプラットフォーム領域の組織構成
	&:nth-child(4) {
		&:after {
			width: 150%;
			top: -10%;
			left: -10%;
			transform-origin: left top;
			@media print, screen and (min-width: 920px) {
				top: 5%;
				left: 0;
			}
		}
		&:before {
			content: none;
		}
	}
	// 今後の展望
	&:nth-child(5) {
		&:after {
			content: none;
		}
		&:before {
			width: 150%;
			bottom: -5%;
			transform-origin: left top;
			left: -10%;
			@media print, screen and (min-width: 920px) {
				transform-origin: right top;
				left: auto;
				right: 1px;
				bottom: 15%;
				width: 100vw;
			}
		}
	}
	// 求める人物像
	&:nth-child(n + 6) {
		&::after {
			content: none;
		}
		&:before {
			content: none;
		}
	}
}

.column.keyman {
	@media print, screen and (min-width: 1161px) {
		margin-bottom: 0;
	}
	& + .column.keyman {
		@media print, screen and (min-width: 1161px) {
			margin-top: 60px;
		}
	}
	.content-inner {
		@media print, screen and (min-width: 1161px) {
			padding-bottom: 0;
		}
	}
	.keyman_flex {
		display: flex;
		flex-direction: column;
		align-items: center;
		@media print, screen and (min-width: 1161px) {
			flex-direction: row;
			align-items: flex-end;
		}
	}
	.keyman_title {
		display: flex;
		flex-direction: column;
		gap: 1em;
		position: relative;
		z-index: 1;
		width: 80vw;
		margin: 0;
		padding: 2em 0 2em 2em;
		box-sizing: border-box;
		font-family: 'ots-mincho', serif;
		background-color: #543193;
		color: #fff;
		@media print, screen and (min-width: 1161px) {
			justify-content: center;
			width: 380px;
			flex: 0 0 380px;
			padding: 2em 0 2em 3em;
			margin-bottom: 40px;
			margin-right: -90px;
		}
		span {
			display: block;
			img {
				display: block;
				width: 16px;
				@media print, screen and (min-width: 1161px) {
					width: 22px;
				}
			}
		}
		.top {
			display: flex;
			align-items: center;
			font-size: 12px;
			gap: 1em;
			font-weight: normal;
			@media print, screen and (min-width: 1161px) {
				font-size: 16px;
				letter-spacing: -0.05em;
			}
		}
		.mid {
			font-size: 19px;
			line-height: calc(70 / 38);
			font-weight: normal;
			letter-spacing: 0;
			@media print, screen and (min-width: 1161px) {
				letter-spacing: -0.05em;
				font-size: 26px;
				line-height: calc(50 / 26);
			}
		}
		.bottom {
			font-weight: bold;
			font-size: 12px;
			font-family: 'Noto Sans JP', sans-serif;
			letter-spacing: 0.1em;
			@media print, screen and (min-width: 1161px) {
				font-size: 14px;
			}
		}
	}
	.keyman_image {
		position: relative;
		z-index: 0;
		margin: -20px calc(50% - 50vw) 0;
		width: 100vw;
		@media print, screen and (min-width: 1161px) {
			flex: 0 0 630px;
			width: 630px;
			margin: 0;
		}
		img {
			vertical-align: bottom;
		}
	}
}
.title-wrap {
	top: -1.5em;
	display: inline-block;
	background-color: #543193;
	color: #fff;
	margin: 0;
	position: absolute;
	@media print, screen and (max-width: 1160px) {
		top: -30px;
		font-size: 12px;
	}
	h3 {
		font-family: 'ots-mincho';
		padding: 0 2em;
		text-align: left;
		position: relative;
		letter-spacing: 0.05em;
		font-weight: normal;
		@media print, screen and (min-width: 1161px) {
			padding: 0 3.5em;
			font-size: 16px;
			letter-spacing: 0;
		}
		&:before {
			content: '';
			width: 15px;
			height: 2px;
			display: block;
			background-color: #fff;
			top: calc(50% - 2px);
			position: absolute;
			left: 0;
		}
		&:after {
			content: '';
			width: 15px;
			height: 2px;
			display: block;
			background-color: #fff;
			top: calc(50% - 2px);
			position: absolute;
			right: 0;
		}
	}
}
.image {
	margin: 0 calc(50% - 50vw);
	width: 100vw;
	height: 32.67vw;
	@media print, screen and (min-width: 1160px) {
		margin: 0;
		width: 100%;
		height: 300px;
	}
	img {
		vertical-align: middle;
	}
}
.content {
	background-color: #fff;
}
.content-inner {
	padding: 120px 100px 3.5em 100px;
	@media print, screen and (max-width: 1160px) {
		padding: 80px 5% 50px 5%;
	}
	&.grayBox {
		padding-top: 2.5em;
		padding-bottom: 1.5em;
		background-color: #e7e7e7;
		@media print, screen and (min-width: 1161px) {
			padding: 3em 50px;
		}
	}
	&.underImage {
		padding: 50px 100px 100px 100px;
		@media print, screen and (max-width: 1160px) {
			padding: 40px 5% 50px 5%;
		}
	}
	&.bgGray {
		background-color: #e7e7e7;
	}
}

.grayBoxContainer {
	display: flex;
	flex-direction: column;
	gap: 40px;
	@media print, screen and (min-width: 1161px) {
		flex-wrap: wrap;
		flex-direction: row;
		gap: 5px;
	}
}

.grayBox {
	position: relative;
	@media print, screen and (min-width: 1161px) {
		flex: 0 1 calc(50% - 5px);
		box-sizing: border-box;
	}
	&_title {
		display: inline-block;
		position: absolute;
		top: -1.5em;
		left: 50%;
		transform: translateX(-50%);
		background-color: #543193;
		width: 230px;
		padding: 1em 0;
		margin: 0;
		color: #fff;
		font-size: 12px;
		font-weight: bold;
		text-align: center;
		line-height: 1;
		letter-spacing: 0.05em;
		white-space: nowrap;
		@media print, screen and (min-width: 1161px) {
			box-sizing: border-box;
			width: 260px;
			font-size: 13px;
			padding: 1em 0;
		}
	}
	&_desc {
		font-size: 12px;
		line-height: 2;
		text-align: justify;
		text-justify: inter-ideograph;
		text-justify: inter-character;
		@media print, screen and (min-width: 1161px) {
		}
	}
}

.content-lead {
	&:not(:first-of-type) {
		margin-top: 4em;
		@media print, screen and (min-width: 1161px) {
			margin-top: 3em;
		}
	}
	@media print, screen and (min-width: 1161px) {
		display: flex;
		align-items: center;
		gap: 40px;
	}
}

.content-num {
	width: 31px;
	@media print, screen and (min-width: 1161px) {
		width: 37px;
	}
	&--1 {
		width: 25px;
		@media print, screen and (min-width: 1161px) {
			width: 30px;
		}
	}
	img {
		width: 100%;
	}
}

.content-iconFlex {
	@media print, screen and (min-width: 1161px) {
		display: flex;
		justify-content: flex-end;
		gap: 50px;
		.content-text {
			flex: 0 0 530px;
		}
	}
	& + & {
		margin-top: 4em;
		@media print, screen and (min-width: 1161px) {
			margin-top: 3em;
		}
	}
	&.--person {
		@media print, screen and (min-width: 1161px) {
			gap: 50px;
		}
	}
}
.content-iconFlex.--person + .content-iconFlex.--person {
	@media print, screen and (min-width: 1161px) {
		margin-top: 2.5em;
	}
}

.content-iconContainer {
	display: flex;
	align-items: center;
	gap: 30px;
	@media print, screen and (min-width: 1161px) {
		flex: 1 1 auto;
		gap: 10px;
		flex-direction: column;
	}
	&.--person {
		gap: 0;
		flex-direction: column;
		.content-icon {
			@media print, screen and (min-width: 1161px) {
				width: 55px;
				margin-top: 5px;
			}
		}
	}
}
.content-icon {
	&--1 {
		width: 52px;
		@media print, screen and (min-width: 1161px) {
			width: 70px;
		}
	}
	&--2 {
		width: 45px;
		@media print, screen and (min-width: 1161px) {
			width: 65px;
		}
	}
	&--3 {
		width: 49px;
		@media print, screen and (min-width: 1161px) {
			width: 62px;
		}
	}
}

.content-iconText {
	font-size: 12px;
	font-weight: bold;
	margin: 0;
	@media print, screen and (min-width: 1161px) {
		font-size: 14px;
	}
}

.content-catch {
	font-size: 26px;
	font-family: 'ots-mincho', serif;
	letter-spacing: 0;
	margin: 0;
	line-height: calc(61 / 26);
	@media print, screen and (max-width: 1160px) {
		margin-top: 0.5em;
		font-size: 18px;
		line-height: calc(68 / 36);
	}
}
.content-text {
	margin-top: 4em;
	font-size: 12px;
	text-align: justify;
	// @media print, screen and (min-width: 1161px) {
	// 	margin-top: 4em;
	// }
	&.--interview p {
		@media print, screen and (min-width: 1161px) {
			font-size: 14px;
			line-height: calc(30 / 14);
		}
	}
	p {
		font-family: 'Noto Sans JP', sans-serif;
		font-weight: 500;
	}
	p:not(:first-of-type) {
		margin-top: 2.5em;
		@media print, screen and (min-width: 1161px) {
			margin-top: 2em;
		}
	}
	p.content-textLead {
		font-family: 'ots-mincho', serif;
		font-size: 18px;
		line-height: calc(68 / 36);
		letter-spacing: 0;
		margin-top: 1.5em;
		@media print, screen and (min-width: 1160px) {
			margin-top: -0.5em;
			font-size: 23px;
			line-height: calc(41 / 23);
		}
	}
	p.lg {
		font-family: 'Noto Serif JP', serif;
		font-size: 18px;
		line-height: calc(68 / 36);
		letter-spacing: 0;
		margin-top: 0;
		@media print, screen and (min-width: 1160px) {
			font-size: 26px;
			line-height: calc(61 / 26);
		}
	}
}
.case {
	background-color: #dddddd;
}
.case-inner {
	padding: 0 100px 50px 100px;
	@media print, screen and (max-width: 1160px) {
		padding: 0 5% 50px 5%;
	}
}
.case-title {
	font-size: 14px;
	background-color: #543193;
	color: #fff;
	display: inline-block;
	margin: 0;
	padding: 0 30px;
}
.case-text {
	font-size: 12px;
	margin-top: 40px;
	text-align: justify;
}
.case-catch {
	font-size: 17px;
}

.linkBox {
	@media print, screen and (min-width: 1161px) {
		margin-top: 140px;
		max-width: 830px;
	}
	&_title {
		display: inline-block;
		position: relative;
		margin: 0;
		padding: 1em 2em 1em 2.5em;
		background-color: #e7e7e7;
		color: #543193;
		font-weight: bold;
		font-size: 11.5px;
		line-height: calc(40 / 23);
		letter-spacing: 0.05em;
		@media print, screen and (min-width: 1161px) {
			font-size: 13px;
		}
		&::before {
			content: '';
			display: inline-block;
			position: absolute;
			left: 0;
			top: 50%;
			transform: translateY(-50%);
			width: 1em;
			height: 2px;
			background-color: currentColor;
		}
	}
	&_inner {
		position: relative;
	}
	&_text {
		position: absolute;
		top: 50%;
		left: 1.5em;
		transform: translateY(-50%);
		margin: 0;
		font-family: 'Noto Serif JP', serif;
		color: #fff;
		letter-spacing: 0;
		font-size: 15px;
		line-height: calc(64 / 30);
		@media print, screen and (min-width: 1161px) {
			left: 3.5em;
			font-size: 24px;
			line-height: calc(53 / 24);
			letter-spacing: -0.1em;
		}
	}
	&_bg {
		display: block;
		source,
		img {
			vertical-align: bottom;
		}
	}
}

.u-mt0-pc {
	@media print, screen and (min-width: 1161px) {
		margin-top: 0 !important;
	}
}

.u-bg0-pc {
	@media print, screen and (min-width: 1161px) {
		background-color: transparent !important;
	}
}

.u-mt0-pc {
	@media print, screen and (min-width: 1161px) {
		margin-top: 0 !important;
	}
}
.u-mt2em-pc {
	@media print, screen and (min-width: 1161px) {
		margin-top: 2em !important;
	}
}
.u-mt3em-pc {
	@media print, screen and (min-width: 1161px) {
		margin-top: 3em !important;
	}
}
.u-pb3em-pc {
	@media print, screen and (min-width: 1161px) {
		padding-bottom: 3em !important;
	}
}
.u-pt4em-pc {
	@media print, screen and (min-width: 1161px) {
		padding-top: 4em !important;
	}
}
.u-pt5em-pc {
	@media print, screen and (min-width: 1161px) {
		padding-top: 5em !important;
	}
}
.u-pb5em-pc {
	@media print, screen and (min-width: 1161px) {
		padding-bottom: 5em !important;
	}
}
.u-pb55em-pc {
	@media print, screen and (min-width: 1161px) {
		padding-bottom: 5.5em !important;
	}
}
.u-pt6em-pc {
	@media print, screen and (min-width: 1161px) {
		padding-top: 6em !important;
	}
}
.u-pt65em-pc {
	@media print, screen and (min-width: 1161px) {
		padding-top: 6.5em !important;
	}
}
.u-pt7em-pc {
	@media print, screen and (min-width: 1161px) {
		padding-top: 7em !important;
	}
}

.u-wsn-pc {
	@media print, screen and (min-width: 1161px) {
		white-space: nowrap !important;
	}
}

.u-LS10-pc {
	@media print, screen and (min-width: 1161px) {
		letter-spacing: -0.1em !important;
	}
}
.u-LS05-pc {
	@media print, screen and (min-width: 1161px) {
		letter-spacing: -0.05em !important;
	}
}
.u-ls10-pc {
	letter-spacing: 0.1em !important;
}
</style>
